<template>
  <div class="page-content">
    <div class="card">
      <div class="card-header">
        <h1 class="card-header-title">{{ content.title }}</h1>
        <p class="card-header-description">{{ content.description }}</p>
      </div>
      { Carosel goes here }
      <CustomButton variation="primary" :onClick="action"
        >Continue</CustomButton
      >
    </div>
  </div>
</template>
<script>
import CustomButton from "@/components/CustomButton.vue";
export default {
  components: {
    CustomButton,
  },
  props: {
    action: {
      type: Function,
      required: true,
    },
    content: {
      type: Object,
      required: true,
      default: () => ({
        content: String,
        description: String,
        image: String,
      }),
    },
  },
};
</script>
